export default __webpack_public_path__ + "static/media/Inc.5c2896cc.svg";